module.exports = __webpack_public_path__ + "img/形状 19@2x.b74bba80.png";